export default "__VITE_ASSET__CyI0ecFe__"